import { useContext, useEffect } from 'react';
import { matchRoutes } from 'react-router-dom';
import PermissionContext from './PermissionContext';
import { useLocalObservable } from 'mobx-react-lite';
import { cloneDeep, isNil } from 'lodash-es';
// import routes from '@/config/routes';
// import { includes } from 'lodash-es';

type PermissionApi = {
  hasPageElementPermission: Function,
  hasRoutePermission: Function,
}

function usePermission(): PermissionApi {
  const { pageElementPermission, routePermission } = useContext(PermissionContext);
  const store = useLocalObservable(() => ({
    routePermission: routePermission,
    pageElementPermission: pageElementPermission,
    setConfig(params: any) {
      this.routePermission = params.routePermission;
      this.pageElementPermission = params.pageElementPermission;
    },
    hasPageElementPermission(needPermission: string) {
      return (this.pageElementPermission || []).some(d => d == needPermission);
    },
    hasRoutePermission(path: string = '') {
      const match = matchRoutes(this.routePermission?? [], path);
      return !isNil(match);
    },
  }));
  useEffect(() => {
    store.setConfig(cloneDeep({
      routePermission,
      pageElementPermission,
    }));
  }, [routePermission, pageElementPermission]);
  return store;
}


export default usePermission;
